import { BUTTON_PRESS } from './baseEvents'

export const GTZ_ENTER = `${BUTTON_PRESS} Grid Testing Zone Enter`
export const GTZ_RUN_TEST = `${BUTTON_PRESS} Grid Testing Zone Run Test`
export const GTZ_SAVE_GRID = `${BUTTON_PRESS} Grid Testing Zone Save Grid`
export const GTZ_JOB_COMPLETED = 'Grid Testing Zone Job Completed'
export const GTZ_JOB_FAILED = 'Grid Testing Zone Job Failed'
